import styled from 'styled-components';

interface BaseLineProps {
  margin?: string;
}

const StyledLine = styled.div<{
  $margin?: string;
}>`
  width: 100%;
  height: 1px;
  background-color: #e6ebf4;
  ${(props) => props.$margin && `margin: ${props.$margin};`}
`;

export const BaseLine = ({ margin }: BaseLineProps) => {
  return <StyledLine $margin={margin} />;
};
